// Google Analytics (GA4) helpers. gtag.js is loaded in public/index.html.
export const GA_MEASUREMENT_ID = 'G-ECWRZ6DQDX';

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

// Fire a GA4 event (safe no-op if gtag hasn't loaded / is blocked)
export const trackEvent = (name, params = {}) => {
  if (hasGtag()) {
    window.gtag('event', name, params);
  }
};

// Update Consent Mode v2 signals based on the user's cookie-banner choice
export const updateConsent = (granted) => {
  const v = granted ? 'granted' : 'denied';
  if (hasGtag()) {
    window.gtag('consent', 'update', {
      ad_storage: v,
      ad_user_data: v,
      ad_personalization: v,
      analytics_storage: v,
    });
  }
};

export const trackPageView = (path) => {
  if (hasGtag()) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
    });
  }
};
